import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PT from 'prop-types';
import classNames from 'classnames';
import { Responsive } from 'common/components';
import _ from 'lodash';
import iconPlay from 'assets/client/imgs/icon-play_2x.png';
import * as css from './SliderComponent.scss';
import { PODCAST_ROOT_ROUTE } from '../../../constants';

class SliderSlide extends React.PureComponent {
	timeout = null;

	static propTypes = {
		name: PT.string.isRequired,
		subtitle: PT.string.isRequired,
		id: PT.string.isRequired,
		bannerImg: PT.shape({
			selected: PT.string,
			file: PT.shape({
				url: PT.string,
			}),
		}).isRequired,
		mobileBannerImg: PT.shape({
			selected: PT.string,
			file: PT.shape({
				url: PT.string,
			}),
		}).isRequired,
		className: PT.string,
		content: PT.shape({
			text: PT.string,
		}).isRequired,
		isPodcast: PT.bool,
		history: PT.shape({
			push: PT.func,
		}).isRequired,
		onSlideClick: PT.func,
	};

	static defaultProps = {
		className: '',
		isPodcast: false,
		onSlideClick: () => {},
	};

	componentDidMount() {
		clearTimeout(this.timeout);
	}

	onSlideClick = () => {
		const { isPodcast, history, id } = this.props;

		this.timeout = setTimeout(() => {
			if (!isPodcast) {
				history.push({
					pathname: `${PODCAST_ROOT_ROUTE}/${id}`,
					state: {
						from: 'inAnimFreeze',
					},
				});
			} else {
				history.push(`${PODCAST_ROOT_ROUTE}/${id}`);
				this.props.onSlideClick(id);
			}
		}, 10);
	};

	render() {
		const { name, bannerImg, mobileBannerImg, id, className, content, subtitle } = this.props;

		return (
			<div key={`slide-${id}`} className={classNames(className, css.slide)}>
				<Responsive query={Responsive.DESKTOP}>
					<Link to={`${PODCAST_ROOT_ROUTE}/${id}`} className={css.slideLink}>
						<div
							className={css.slideImg}
							style={{ backgroundImage: `url(${_.get(bannerImg, 'file.url', '')})` }}
						>
							<img src={iconPlay} alt="" className={css.iconPlay} />
							{/* <button type="button" className={css.iconPlay}>
								<i className={css.play} />
							</button> */}
						</div>
						<p className={css.slideTitle}>{name}</p>
					</Link>
				</Responsive>
				<Responsive query={Responsive.MOBILE}>
					<div
						className={classNames(css.slideLink, css.slideImg)}
						style={{ backgroundImage: `url(${_.get(mobileBannerImg, 'file.url', '')})` }}
						onClick={this.onSlideClick}
					>
						<div className={css.slideLinkInner}>
							<img src={iconPlay} alt="" className={css.iconPlay} />
							{/* <button type="button" className={css.iconPlay}>
								<i className={css.play} />
							</button> */}
							<p className={css.slideTitle}>{name}</p>
						</div>
					</div>
					<div className={css.wrapCenter}>
						<button type="button" className={css.closeInfoSection} />
						<div className={css.title}>
							<p>{name}</p>
							<span>{subtitle}</span>
						</div>
						<div className={css.text} dangerouslySetInnerHTML={{ __html: content.text }} />
					</div>
				</Responsive>
			</div>
		);
	}
}

export default withRouter(SliderSlide);
